<template>
  <div>
    <h4><i class="fas fa-cart-arrow-down"></i> {{ title || 'Discounts'}}</h4>
    <b-table :items="discounts" :fields="['first_name', 'authority', 'discount_type', 'account_ref', 'address_line_1']">
      <template #head(first_name)>Name</template>
      <template #cell(first_name)="data">{{ data.value }} {{ data.item.last_name }}</template>
      <template #cell(account_ref)="data"><code>{{ data.value }}</code></template>
      <template #cell(authority)="data"><authority :authority="data.value"/></template>
    </b-table>
  </div>
</template>

<script>
import Authority from '../Authority.vue'

export default {
  components: { Authority },
  props: ['discounts', 'title'],
};
</script>

